import React, { useCallback } from 'react'
import { Alert } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { TDocument } from '../../../common/validations/document'

import { useOpenFile } from 'hooks/useOpenFile/useOpenFile'
import { useAPIGetContractDocument } from 'api/apiHooks/useAPIGetContractDocument'
import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'
import { FileLink } from 'components/FileLink/FileLink'

interface Props {
  document: TDocument
}

const LINK_DOCUMENT_CONTENT_TYPE = 'text/uri-list'

export const DocumentLink: React.FC<Props> = ({ document }) => {
  const { t } = useTranslation(['documents'])
  const isLinkDocument = document.documentType === LINK_DOCUMENT_CONTENT_TYPE
  const { currentContractId } = useCurrentContract()
  const { refetch: fetchSignedUrl } = useAPIGetContractDocument(
    currentContractId,
    document.uuid
  )

  const getSignedUrl = useCallback(async () => {
    const { data } = await fetchSignedUrl()

    return data?.url
  }, [fetchSignedUrl])

  const { openFile, isOpening, hasOpenError } = useOpenFile(getSignedUrl)

  const handleClick = isLinkDocument
    ? () => {
        if (document.linkUrl) {
          window.open(document.linkUrl, '_blank', 'noopener,noreferrer')
        }
      }
    : openFile

  return (
    <div>
      {hasOpenError && (
        <Alert variant="danger" className="w-full justify-start mb-2">
          {t('documents:errors.failedToOpen')}
        </Alert>
      )}
      <FileLink
        name={document.name}
        onClick={handleClick}
        loading={isOpening}
      />
    </div>
  )
}
